import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { OrganizationResidenceTodoRuleApiService } from '@_services/api/organization-residence-todo-rule-api.service';
import { AppState } from '@_store/index.reducers';
import { GeneratedOrganizationResidenceTodoRuleEffects } from './organization-residence-todo-rule-generated.effects';

@Injectable()
export class OrganizationResidenceTodoRuleEffects extends GeneratedOrganizationResidenceTodoRuleEffects {
  constructor(
    actions$: Actions,
    organizationResidenceTodoRuleApiService: OrganizationResidenceTodoRuleApiService,
    store$: Store<AppState>
  ) {
    super(actions$, organizationResidenceTodoRuleApiService, store$);
  }
}
